// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2pqC1{-ms-flex-direction:column;flex-direction:column;-ms-flex-align:end;align-items:flex-end}._2pqC1,._3CPoa{display:-ms-flexbox;display:flex;width:100%}._3CPoa{-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}._3CPoa>div:first-child{width:40%}._3CPoa>div:last-child{width:60%}._3asaO{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:35px}._2QrY-{font-size:22px;font-weight:700;margin-bottom:25px}._3obtJ,._2QrY-{color:#4d4d4d;line-height:30px}._3obtJ{font-size:18px;text-align:justify}._3430n{-ms-flex-pack:justify;justify-content:space-between;list-style:inside;width:100%}._3430n,._13v3M{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}._13v3M{-ms-flex-wrap:wrap;flex-wrap:wrap;width:60%;-ms-flex-pack:distribute;justify-content:space-around}._2NvV8{border:solid #000;border-width:0 0 3px;color:#000!important}._3XmZ3{font-size:16px;font-weight:400;color:#9b9b9b;border-radius:0;min-width:125px}", ""]);
// Exports
exports.locals = {
	"valuesContainer": "_2pqC1",
	"valueTab": "_3CPoa",
	"contentContainer": "_3asaO",
	"valueTitle": "_2QrY-",
	"description": "_3obtJ",
	"rowList": "_3430n",
	"tabContainer": "_13v3M",
	"activeTab": "_2NvV8",
	"tab": "_3XmZ3"
};
module.exports = exports;
